

// // src/pages/EmiDueReportMember.js
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";

// const EmiDueReportMember = () => {
//   const [memberId, setMemberId] = useState("");
//   const [memberOptions, setMemberOptions] = useState([]);
//   const [emis, setEmis] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [paying, setPaying] = useState(null); // track paying EMI ID

//   // 🔹 Fetch Member List
//   useEffect(() => {
//     const fetchMembers = async () => {
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/group-loan/emi-demandsheet?superAdminId=${localStorage.getItem('adminuserId')}`
//         );
//         if (res.data.success) {
//           setMemberOptions(res.data.data);
//         }
//       } catch (err) {
//         console.error("Error fetching members:", err);
//       }
//     };
//     fetchMembers();
//   }, []);

//   // 🔹 Fetch EMI Report for selected member
//   const fetchEmis = async () => {
//     if (!memberId) {
//       alert("Please select a member first");
//       return;
//     }
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `https://payyug.in/api/group-loan/emi-due-report-all?memberId=${memberId}`
//       );
//       setEmis(res.data.data || []);
//     } catch (error) {
//       console.error("Error fetching EMIs:", error);
//       alert("Failed to fetch EMI data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🔹 Pay EMI
//   const payEmi = async (emiId) => {
//     if (!window.confirm(`Are you sure you want to pay EMI ${emiId}?`)) return;

//     try {
//       setPaying(emiId);
//       const payload = {
//         paidBy: "Collector1", // 🔹 you can make this dynamic if needed
//         paidDate: new Date().toISOString().split("T")[0], // yyyy-mm-dd
//       };

//       const res = await axios.put(
//         `https://payyug.in/api/group/emi/${emiId}/collect`,
//         payload
//       );

//       if (res.data.success) {
//         alert(`EMI ${emiId} marked as paid ✅`);
//         fetchEmis(); // refresh list
//       } else {
//         alert(res.data.message || "Payment failed ❌");
//       }
//     } catch (err) {
//       console.error("Error paying EMI:", err);
//       alert("Payment request failed");
//     } finally {
//       setPaying(null);
//     }
//   };

//   // 🔹 Export Functions
//   const exportCSV = () => {
//     const csvRows = [
//       ["EMI ID", "Due Date", "Total Amount", "Paid"],
//       ...emis.map((e) => [
//         e.id,
//         new Date(e.dueDate).toLocaleDateString(),
//         e.total,
//         e.paid ? "Yes" : "No",
//       ]),
//     ];
//     const csvContent = csvRows.map((r) => r.join(",")).join("\n");
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     saveAs(blob, `emi_report_member_${memberId}.csv`);
//   };

//   const exportExcel = () => {
//     const ws = XLSX.utils.json_to_sheet(
//       emis.map((e) => ({
//         "EMI ID": e.id,
//         "Due Date": new Date(e.dueDate).toLocaleDateString(),
//         "Total Amount": e.total,
//         Paid: e.paid ? "Yes" : "No",
//       }))
//     );
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "EMI Report");
//     XLSX.writeFile(wb, `emi_report_member_${memberId}.xlsx`);
//   };

//   const exportPDF = () => {
//     const doc = new jsPDF();
//     doc.text(`EMI Report for Member ${memberId}`, 14, 15);
//     doc.autoTable({
//       head: [["EMI ID", "Due Date", "Total Amount", "Paid"]],
//       body: emis.map((e) => [
//         e.id,
//         new Date(e.dueDate).toLocaleDateString(),
//         e.total,
//         e.paid ? "Yes" : "No",
//       ]),
//     });
//     doc.save(`emi_report_member_${memberId}.pdf`);
//   };

//   return (
//     <div className="container" style={{ padding: "30px" }}>
//       <div
//         style={{
//           maxWidth: "900px",
//           margin: "auto",
//           background: "#fff",
//           padding: "25px",
//           borderRadius: "12px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//         }}
//       >
//         <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
//           📋 EMI Due Report (Member-wise)
//         </h2>

//         {/* Dropdown */}
//         <div
//           style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
//         >
//           <label style={{ fontWeight: "600" }}>Select Member: </label>
//           <select
//             value={memberId}
//             onChange={(e) => setMemberId(e.target.value)}
//             style={{
//               marginLeft: "10px",
//               padding: "8px",
//               borderRadius: "6px",
//               border: "1px solid #ccc",
//               flex: 1,
//             }}
//           >
//             <option value="">-- Select --</option>
//             {memberOptions.map((m) => (
//               <option key={m.memberId} value={m.memberId}>
//                 {m.memberId || `Member ${m.memberId}`}
//               </option>
//             ))}
//           </select>

//           <button
//             onClick={fetchEmis}
//             style={{
//               marginLeft: "15px",
//               padding: "8px 14px",
//               background: "#007bff",
//               color: "white",
//               border: "none",
//               borderRadius: "6px",
//               cursor: "pointer",
//             }}
//           >
//             Fetch EMIs
//           </button>
//         </div>

//         {/* Export Buttons */}
//         {emis.length > 0 && (
//           <div style={{ marginBottom: "15px", textAlign: "right" }}>
//             <button onClick={exportCSV} style={btnStyle}>
//               Export CSV
//             </button>
//             <button onClick={exportExcel} style={btnStyle}>
//               Export Excel
//             </button>
//             <button onClick={exportPDF} style={btnStyle}>
//               Export PDF
//             </button>
//           </div>
//         )}

//         {/* EMI List */}
//         {loading && <p>Loading...</p>}
//         {!loading && emis.length === 0 && memberId && (
//           <p>No unpaid EMIs found for Member {memberId}</p>
//         )}

//         {emis.length > 0 && (
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               marginTop: "15px",
//             }}
//           >
//             <thead>
//               <tr style={{ background: "#f1f1f1" }}>
//                 <th style={thStyle}>Sr No.</th>
//                 <th style={thStyle}>EMI ID</th>
//                 <th style={thStyle}>Due Date</th>
//                 <th style={thStyle}>Principal</th>
//                 <th style={thStyle}>Interest</th>
//                 <th style={thStyle}>Total Amount</th>
//                 <th style={thStyle}>Paid</th>
//                 <th style={thStyle}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {emis.map((emi, idx) => (
//                 <tr
//                   key={emi.id}
//                   style={{
//                     background: idx % 2 === 0 ? "#fff" : "#f9f9f9",
//                     textAlign: "center",
//                   }}
//                 >
//                   <td style={tdStyle}>{idx + 1}</td>
//                   <td style={tdStyle}>{emi.id}</td>
//                   <td style={tdStyle}>
//                     {new Date(emi.dueDate).toLocaleDateString()}
//                   </td>
//                   <td style={tdStyle}>₹ {emi.principalComponent}</td>
//                   <td style={tdStyle}>₹ {emi.interestComponent}</td>
//                   <td style={tdStyle}>₹ {emi.total}</td>
//                   <td style={tdStyle}>{emi.paid ? "✅ Yes" : "❌ No"}</td>
//                   <td style={tdStyle}>
//                     {!emi.paid ? (
//                       <button
//                         onClick={() => payEmi(emi.id)}
//                         style={{
//                           ...btnStyle,
//                           background: "#ff9800",
//                           fontSize: "13px",
//                           padding: "5px 10px",
//                         }}
//                         disabled={paying === emi.id}
//                       >
//                         {paying === emi.id ? "Paying..." : "Pay"}
//                       </button>
//                     ) : (
//                      <button
                        
//                         style={{
//                           ...btnStyle,
//                           background: "#0a7c0aff",
//                           fontSize: "13px",
//                           padding: "5px 10px",
//                         }}
//                       >
//                         {paying === emi.id ? "Paying..." : "Pay"}
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// };

// // Reusable styles
// const btnStyle = {
//   padding: "6px 12px",
//   marginLeft: "8px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
//   background: "#28a745",
//   color: "white",
//   fontWeight: "600",
// };

// const thStyle = {
//   padding: "10px",
//   border: "1px solid #ddd",
//   textAlign: "center",
//   fontWeight: "600",
// };

// const tdStyle = {
//   padding: "8px",
//   border: "1px solid #ddd",
// };

// export default EmiDueReportMember;








// src/pages/EmiDueReportMember.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const EmiDueReportMember = () => {
  const [loanAccountNumber, setLoanAccountNumber] = useState("");
  const [memberOptions, setMemberOptions] = useState([]);
  const [emis, setEmis] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  // Payment dialog
  const [showDialog, setShowDialog] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [paymentData, setPaymentData] = useState({
    amount: "",
    paidBy: "",
    paymentMode: "cash",
    remarks: "",
  });
  const [paying, setPaying] = useState(false);

  // Advance / bulk dialog
  const [showAdvanceDialog, setShowAdvanceDialog] = useState(false);
  const [advanceData, setAdvanceData] = useState({
    amount: "",
    paidBy: "",
    paymentMode: "cash",
    remarks: "",
  });

  // 🔹 Fetch members (loan accounts)
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/group-loan/all-member-loan?superAdminId=${localStorage.getItem('adminuserId')}`
        );
        if (res.data.success) setMemberOptions(res.data.data);
      } catch (err) {
        console.error("Error fetching members:", err);
      }
    };
    fetchMembers();
  }, []);

  // 🔹 Fetch EMI report
  const fetchEmis = async () => {
    if (!loanAccountNumber) {
      alert("Please select a loanAccountNumber first");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.get(
        `https://payyug.in/api/groupmember-emi-report?loanAccountNumber=${loanAccountNumber}`
      );
      setEmis(res.data.data || []);
      setSummary(res.data.summary || null);
    } catch (error) {
      console.error("Error fetching EMIs:", error);
      alert("Failed to fetch EMI data");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Open Pay Dialog
  const openPayDialog = (emi) => {
    setSelectedEmi(emi);
    setPaymentData({
      amount: emi.total - (emi.paidAmount || 0),
      paidBy: "Collector1",
      paymentMode: "cash",
      remarks: "",
    });
    setShowDialog(true);
  };

  // 🔹 Handle Payment
  const handlePayment = async () => {
    if (!selectedEmi) return;
    try {
      setPaying(true);
      const payload = {
        emiId: selectedEmi.id,
        paidBy: paymentData.paidBy,
        paidAt: new Date().toISOString().split("T")[0],
        paidAmount: Number(paymentData.amount),
        paymentMode: paymentData.paymentMode,
        remarks: paymentData.remarks,
      };
      const res = await axios.post(
        `https://payyug.in/api/group-emi/${selectedEmi.id}/collect`,
        payload
      );
      if (res.data.success) {
        alert("Payment recorded ✅");
        setShowDialog(false);
        fetchEmis();
      } else {
        alert(res.data.error || "Payment failed ❌");
      }
    } catch (err) {
      console.error("Error paying EMI:", err);
    } finally {
      setPaying(false);
    }
  };

  // 🔹 Handle Advance Payment
  const handleAdvancePayment = async () => {
    try {
      const payload = {
        loanAccountNumber,
        paidBy: advanceData.paidBy,
        amount: Number(advanceData.amount),
        paymentMode: advanceData.paymentMode,
        remarks: advanceData.remarks,
      };
      const res = await axios.post(
        `https://payyug.in/api/group-emi/advance-collect`,
        payload
      );
      if (res.data.success) {
        alert("Advance Payment recorded ✅");
        setShowAdvanceDialog(false);
        fetchEmis();
      } else {
        alert(res.data.error || "Advance Payment failed ❌");
      }
    } catch (err) {
      console.error("Error advance payment:", err);
    }
  };

  // 🔹 Export Excel
  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      emis.map((e) => ({
        "EMI No": e.emiNumber,
        "Due Date": new Date(e.dueDate).toLocaleDateString(),
        "Principal": e.principalComponent,
        "Interest": e.interestComponent,
        "Total": e.total,
        "Paid Amount": e.paidAmount,
        "Status": e.status,
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "EMI Report");
    XLSX.writeFile(wb, `emi_report_${loanAccountNumber}.xlsx`);
  };

  return (
    <div className="container" style={{ padding: "30px" }}>
      <div
        style={{
          maxWidth: "1000px",
          margin: "auto",
          background: "#fff",
          padding: "25px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          📋 EMI Due Report (LoanAccount-wise)
        </h2>

        {/* Select Member */}
        <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
          <label style={{ fontWeight: "600" }}>Select Account: </label>
          <select
            value={loanAccountNumber}
            onChange={(e) => setLoanAccountNumber(e.target.value)}
            style={{
              marginLeft: "10px",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              flex: 1,
            }}
          >
            <option value="">-- Select --</option>
            {memberOptions.map((m) => (
              <option key={m.loanAccountNumber} value={m.loanAccountNumber}>
                {m.loanAccountNumber}
              </option>
            ))}
          </select>
          <button onClick={fetchEmis} style={btnStyle}>
            Fetch EMIs
          </button>
        </div>

        {/* Summary */}
        {/* {summary && (
          <div style={{ display: "flex", justifyContent: "space-around", marginBottom: "20px" }}>
            <div><b>Total:</b> {summary.total}</div>
            <div style={{ color: "green" }}><b>Paid:</b> {summary.paid}</div>
            <div style={{ color: "red" }}><b>Remaining:</b> {summary.remaining}</div>
            <div><b>Principal Paid:</b> ₹{summary.totalPrincipalPaid}</div>
            <div><b>Interest Paid:</b> ₹{summary.totalInterestPaid}</div>
            <div><b>Outstanding:</b> ₹{summary.totalOutstandingPrincipal + summary.totalOutstandingInterest}</div>
          </div>
        )} */}
{summary && (
  <div style={{ display: "flex", justifyContent: "space-around", marginBottom: "20px" }}>
    <div><b>Total Emi:</b> {summary.total}</div>
    <div style={{ color: "green" }}><b>Paid Emi :</b> {summary.paid}</div>
    <div style={{ color: "red" }}><b>Remaining Emi :</b> {summary.remaining}</div>
    <div><b>Outstanding:</b> ₹{summary.totalOutstandingPrincipal + summary.totalOutstandingInterest}</div>
  </div>
)}

        {/* Export + Advance Payment */}
        {/* {emis.length > 0 && (
          <div style={{ marginBottom: "15px", textAlign: "right" }}>
            <button onClick={exportExcel} style={btnStyle}>Export Excel</button>
            <button onClick={() => setShowAdvanceDialog(true)} style={{ ...btnStyle, background: "orange", marginLeft: "10px" }}>
              Advance / Bulk Pay
            </button>
          </div>
        )} */}

        {/* EMI Table */}
        {loading && <p>Loading...</p>}
        {!loading && emis.length > 0 && (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f1f1f1" }}>
                <th style={thStyle}>No</th>
                <th style={thStyle}>Due Date</th>
                <th style={thStyle}>Principal</th>
                <th style={thStyle}>Interest</th>
                <th style={thStyle}>Total</th>
                <th style={thStyle}>Paid Amount</th>
                <th style={thStyle}>Advance Amount</th>
                <th style={thStyle}>Status</th>
                {/* <th style={thStyle}>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {emis.map((emi, idx) => (
                <tr key={emi.id} style={{ background: idx % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                  <td style={tdStyle}>{emi.emiNumber}</td>
                  <td style={tdStyle}>{new Date(emi.dueDate).toLocaleDateString()}</td>
                  <td style={tdStyle}>₹{emi.principalComponent}</td>
                  <td style={tdStyle}>₹{emi.interestComponent}</td>
                  <td style={tdStyle}>₹{emi.total}</td>
                  <td style={tdStyle}>₹{emi.paidAmount}</td>
                  <td style={tdStyle}>₹{emi.advanceAmount}</td>
                  <td style={tdStyle}>
                    <span style={{
                      padding: "4px 8px",
                      borderRadius: "6px",
                      color: "white",
                      background: emi.status === "paid" ? "green" :
                                 emi.status === "partial" ? "orange" : "red"
                    }}>
                      {emi.status}
                    </span>
                  </td>
                  {/* <td style={tdStyle}>
                    {emi.status !== "paid" ? (
                      <button onClick={() => openPayDialog(emi)} style={{ ...btnStyle, background: "#007bff" }}>Pay</button>
                    ) : (
                      <button disabled style={{ ...btnStyle, background: "gray" }}>Paid</button>
                    )}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pay Dialog */}
      {showDialog && selectedEmi && (
        <div style={dialogOverlay}>
          <div style={dialogBox}>
            <h3>💳 Pay EMI #{selectedEmi.emiNumber}</h3>
            <input type="number" value={paymentData.amount} onChange={(e) => setPaymentData({ ...paymentData, amount: e.target.value })} style={inputStyle} />
            <input type="text" value={paymentData.paidBy} onChange={(e) => setPaymentData({ ...paymentData, paidBy: e.target.value })} style={inputStyle} />
            <select value={paymentData.paymentMode} onChange={(e) => setPaymentData({ ...paymentData, paymentMode: e.target.value })} style={inputStyle}>
              <option value="cash">Cash</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="upi">UPI</option>
            </select>
            <textarea value={paymentData.remarks} onChange={(e) => setPaymentData({ ...paymentData, remarks: e.target.value })} style={inputStyle} />
            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <button onClick={() => setShowDialog(false)} style={{ ...btnStyle, background: "gray" }}>Cancel</button>
              <button onClick={handlePayment} disabled={paying} style={{ ...btnStyle, marginLeft: "10px" }}>
                {paying ? "Processing..." : "Confirm Pay"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Advance Dialog */}
      {showAdvanceDialog && (
        <div style={dialogOverlay}>
          <div style={dialogBox}>
            <h3>💰 Advance / Bulk Payment</h3>
            <input type="number" placeholder="Amount" value={advanceData.amount} onChange={(e) => setAdvanceData({ ...advanceData, amount: e.target.value })} style={inputStyle} />
            <input type="text" placeholder="Paid By" value={advanceData.paidBy} onChange={(e) => setAdvanceData({ ...advanceData, paidBy: e.target.value })} style={inputStyle} />
            <select value={advanceData.paymentMode} onChange={(e) => setAdvanceData({ ...advanceData, paymentMode: e.target.value })} style={inputStyle}>
              <option value="cash">Cash</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="upi">UPI</option>
            </select>
            <textarea placeholder="Remarks" value={advanceData.remarks} onChange={(e) => setAdvanceData({ ...advanceData, remarks: e.target.value })} style={inputStyle} />
            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <button onClick={() => setShowAdvanceDialog(false)} style={{ ...btnStyle, background: "gray" }}>Cancel</button>
              <button onClick={handleAdvancePayment} style={{ ...btnStyle, marginLeft: "10px" }}>Confirm Pay</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles
const btnStyle = { padding: "6px 12px", border: "none", borderRadius: "6px", cursor: "pointer", background: "#28a745", color: "white", fontWeight: "600" };
const thStyle = { padding: "10px", border: "1px solid #ddd", textAlign: "center", fontWeight: "600" };
const tdStyle = { padding: "8px", border: "1px solid #ddd", textAlign: "center" };
const dialogOverlay = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center" };
const dialogBox = { background: "#fff", padding: "20px", borderRadius: "8px", width: "400px", boxShadow: "0 4px 10px rgba(0,0,0,0.2)" };
const inputStyle = { width: "100%", padding: "8px", margin: "6px 0", border: "1px solid #ccc", borderRadius: "6px" };

export default EmiDueReportMember;